<template>
    <div class="warpper">
        <div class="page-title">修改密码</div>
        <div class="flex flex-direction align-center">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="input-form" label-width="90px">

                <el-form-item label="旧密码" prop="oldpass" class="form-row-item">
                    <el-input type="password" v-model="ruleForm.oldpass" placeholder="请输入旧密码" autocomplete="off"  show-password>
                    </el-input>
                    <div class="text-red">初始密码为手机号</div>
                </el-form-item>
                <el-form-item label="新密码" prop="newpass" class="form-row-item">
                    <el-input type="password" v-model="ruleForm.newpass" placeholder="请输入新密码 （不超过16位的密码）" autocomplete="off"  show-password>
                    </el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="repass" class="form-row-item">
                    <el-input type="password"  v-model="ruleForm.repass" placeholder="请输入确认密码" autocomplete="off"  show-password>
                    </el-input>
                </el-form-item>
                <el-form-item label-width="0">
                    <div class="flex justify-center margin-top">
                        <el-button @click="submitForm('ruleForm')" class="input-form-btn">确认修改</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import {updatePassword} from "@/api/branch";
import rules from "@/utils/rules";
export default {
    name: "Password",
    data() {
        let validatePassSame = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入确认密码'));
            } else if (value !== this.ruleForm.newpass) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                oldpass: '',
                newpass: '',
                repass: '',
            },
            rules: {
                oldpass: [
                    {required: true, message: '请输入旧密码', trigger: 'change'},
                ],
                newpass: [
                    {required: true, message: '请输入新密码', trigger: 'change'},
                    rules.password
                ],
                repass: [
                    {required: true, message: '请输入确认密码', trigger: 'change'},
                    {validator: validatePassSame, trigger: 'change'},
                ],
            },
        }
    },
    created() {
        this.$emit('setIndex', [5,4], '修改密码')
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitChange();
                } else {
                    return false;
                }
            });
        },
        async submitChange(){
            this.loading = true
            let _data = await updatePassword(this.$store.state.user.fhid,this.ruleForm.oldpass, this.ruleForm.newpass, this.ruleForm.repass)
            this.loading = false
            if (_data.status === 200) {
                this.$message.success('修改成功，请重新登录')
                this.$store.dispatch('LogOut').then(() => {
                    this.$router.replace('/login')
                    // location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            }
        }
    }

}
</script>

<style scoped lang="scss">
.warpper {
    padding: 20px 30px;
    background-color: #ffffff;
    border-radius: 10px;
    .input-form{
        width: 605px;
        margin-top: 94px;
        .input-form-title{
            font-size: 28px;
            font-weight: bold;
            color: #262626;
            margin-bottom: 36px;
        }
        .form-row-item {
            color: #262626;
            font-weight: bold;
        }
        .input-form-btn{
            width: 200px;
            height: 40px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
            border-radius: 20px;
            font-size: 16px;
            color: #ffffff;
        }
    }
    .forget{
        font-size: 16px;
        color: #0a2240;
        span{
            color: #69a3dc;
        }
    }
}
</style>